import { Component } from "react";

class Footer extends Component {
    render() {
        return (
            <footer className="footer">
                <a href="https://junocollege.com/">Juno College of Technology ©2020</a>
            </footer>
        )
    }
}

export default Footer;